jQuery(document).ready(function ($) {

  $('.ctn-teaser-post-slider').slick({
    dots: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive:[
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ],
  });

});
